import React from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'
import CouponActions from '../../Redux/CouponRedux'

class IndividualInsurance extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedInsurance: null,
      form: {
        discountable_type: 'insurance',
        discountable_id: ''
      }
    }
  }

  _selectChange = (selectedInsurance) => {
    let form = { ...this.state.form }
    form.discountable_id = selectedInsurance.value
    this.setState({
      selectedInsurance,
      form
    })
  }

  _submit = (event) => {
    event.preventDefault()
    let form = { ...this.state.form }
    if (this.props.source_type === 'coupon-user') {
      let uuid = this.props.uuid
      let data = { uuid, form }
      this.props.postCouponItem(data)
    } else {
      let tag = this.props.tag
      let data = { tag, form }
      this.props.postCouponItemTag(data)
    }
    setTimeout(() => {
      this.props.fetchCouponItem()
    }, 500)
  }

  render () {
    const { insurance } = this.props
    let insurancePicker = []
    insurance.data.map((item, i) => (
      insurancePicker[i] = {
        value: item.id,
        label: item.name
      }
    ))

    return (
      <section>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-10'>
              <Select
                options={insurancePicker}
                value={this.state.selectedInsurance}
                onChange={(selectedInsurance) => this._selectChange(selectedInsurance)}
                placeholder='Select Insurance to add...'
              />
            </div>
            <div className='col-2'>
              <button type='submit' className='btn btn-primary'>Add</button>
            </div>
          </div>
        </form>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  coupon: state.coupon,
  insurance: state.insurance
})

const dispatchToProps = (dispatch) => ({
  postCouponItem: (data) => dispatch(CouponActions.postCouponItemRequest(data)),
  postCouponItemTag: (data) => dispatch(CouponActions.postCouponItemTagRequest(data))
})

export default connect(stateToProps, dispatchToProps)(IndividualInsurance)



// WEBPACK FOOTER //
// ./src/Containers/Coupon/IndividualInsurance.js